import { CardData, CardDiffStatus, CardDiffData } from "./card-data";
import { CardFuncContainer } from "./card-func-container";

const CardFuncEnums = Object.freeze({
  identity: 0,
  leftShift: 1,
  rightShift: 2,
  addToFront: 3,
  prodToBack: 4,
  whereLess: 5,
  whereGreater: 6,
  moduloVal: 7,
  duplicate: 8,
});


const identityCardFunc = (_, cardDataArr) => {
  return cardDataArr.map(cd => new CardData(cd.intVal, cd.cardFuncContainer));
};

const identityCardDiffFunc = (_, cardDataArr) => {
  return cardDataArr
    .map((cd, cdIdx) => new CardDiffData(cd.intVal, cd.cardFuncContainer, CardDiffStatus.unchanged, cdIdx));
};


const identityContainer = new CardFuncContainer(CardFuncEnums.identity, identityCardFunc, identityCardDiffFunc);

const leftShiftCardFunc = (i, cardDataArr) => {
  i = i % cardDataArr.length;

  if (i < 0) {
    return  rightShiftCardFunc(-1*i, cardDataArr)
  }
  // left shift by |i|
  else {
    const clonedDataArr = cardDataArr.map( cd => new CardData(cd.intVal, cd.cardFuncContainer));

    // in splice..the front remains in clonedDataAr...so move that to back
    const toMoveToFront = clonedDataArr.splice(i);
    //clonedDataArr got mutated...

    return toMoveToFront.concat(clonedDataArr);
  }
};

const leftShiftCardDiffFunc = (i, cardDataArr) => {
  i = i % cardDataArr.length;

  if (i < 0) {
    return  rightShiftCardDiffFunc(-1*i, cardDataArr)
  }
  // left shift by |i|
  else {
    const clonedDataArr = cardDataArr
      .map((cd, cdIdx) => new CardDiffData(cd.intVal, cd.cardFuncContainer, CardDiffStatus.unchanged, cdIdx));

    // in splice..the front remains in clonedDataAr...so move that to back
    const toMoveToFront = clonedDataArr.splice(i);
    //clonedDataArr got mutated...

    return toMoveToFront.concat(clonedDataArr);
  }
};

const leftShiftContainer = new CardFuncContainer(CardFuncEnums.leftShift, leftShiftCardFunc, leftShiftCardDiffFunc);

const rightShiftCardFunc = (i, cardDataArr) => {
  i = i % cardDataArr.length;

  if (i < 0) {
    return leftShiftCardFunc(-1*i, cardDataArr)
  }
  // left shift by |i|
  else {
    const clonedDataArr = cardDataArr.map(cd => new CardData(cd.intVal, cd.cardFuncContainer));

    const toMoveToFront = clonedDataArr.splice(cardDataArr.length - i);
    //clonedDataArr got mutated...

    return toMoveToFront.concat(clonedDataArr);
  }
};

const rightShiftCardDiffFunc = (i, cardDataArr) => {
  i = i % cardDataArr.length;

  if (i < 0) {
    return leftShiftCardDiffFunc(-1*i, cardDataArr)
  }
  // left shift by |i|
  else {
    const clonedDataArr = cardDataArr
      .map((cd, cdIdx) => new CardDiffData(cd.intVal, cd.cardFuncContainer, CardDiffStatus.unchanged, cdIdx));

    const toMoveToFront = clonedDataArr.splice(cardDataArr.length - i);
    //clonedDataArr got mutated...

    return toMoveToFront.concat(clonedDataArr);
  }
};

const rightShiftContainer = new CardFuncContainer(CardFuncEnums.rightShift, rightShiftCardFunc, rightShiftCardDiffFunc);

const addToFrontFunc = (i, cardDataArr) => {
  const clonedDataArr = cardDataArr.map((cd, cdIdx) => {
    return cdIdx === 0
      ? new CardData(cd.intVal + i, cd.cardFuncContainer) 
      : new CardData(cd.intVal, cd.cardFuncContainer) 
    });

  return clonedDataArr;
};

const addToFrontDiffFunc = (i, cardDataArr) => {
  const clonedDataArr = cardDataArr.map((cd, cdIdx) => {
    return cdIdx === 0
      ? new CardDiffData(i + cd.intVal, cd.cardFuncContainer, CardDiffStatus.modified, cdIdx)
      : new CardDiffData(cd.intVal, cd.cardFuncContainer, CardDiffStatus.unchanged, cdIdx);
  });

  return clonedDataArr;
};

const addToFrontContainer = new CardFuncContainer(CardFuncEnums.addToFront, addToFrontFunc, addToFrontDiffFunc);

// product?

const prodToBackFunc = (i, cardDataArr) => {
  const clonedDataArr = cardDataArr.map((cd, cdIdx) => {
    return cdIdx === (cardDataArr.length - 1)
      ? new CardData(cd.intVal + i, cd.cardFuncContainer) 
      : new CardData(cd.intVal, cd.cardFuncContainer) 
    });

  return clonedDataArr;
};

const prodToBackDiffFunc = (i, cardDataArr) => {
  const clonedDataArr = cardDataArr.map((cd, cdIdx) => {
    return cdIdx === (cardDataArr.length - 1)
      ? new CardDiffData(i * cd.intVal, cd.cardFuncContainer, CardDiffStatus.modified, cdIdx)
      : new CardDiffData(cd.intVal, cd.cardFuncContainer, CardDiffStatus.unchanged, cdIdx);
  });

  return clonedDataArr;
};

const prodToBackContainer = new CardFuncContainer(CardFuncEnums.prodToBack, prodToBackFunc, prodToBackDiffFunc);

// https://stackoverflow.com/questions/37318808/what-is-the-in-place-alternative-to-array-prototype-filter
function whereInPlace(a, condition) {
  let i = 0, j = 0;

  while (i < a.length) {
    const val = a[i];
    if (condition(val, i, a)) a[j++] = val;
    i++;
  }

  a.length = j;
  return a;
}

// filter...dupe modulo...
const whereLessFunc = (i, cardDataArr) => {
  const clonedDataArr = cardDataArr.map(cd => new CardData(cd.intVal, cd.cardFuncContainer));

  whereInPlace(clonedDataArr, (cardData, aIdx, a) => cardData.intVal < i);

  return clonedDataArr;
}

// can I combine? perhaps...
const whereLessDiffFunc = (i, cardDataArr) => {
  const clonedDataArr = cardDataArr.map((cd, cdIdx) => {
    const diffStatus = (cd.intVal < i) 
      ? CardDiffStatus.unchanged
      : CardDiffStatus.deleted;

    return new CardDiffData(cd.intVal, cd.cardFuncContainer, diffStatus, cdIdx)
  });


  return clonedDataArr;
}

const whereLessContainer  = new CardFuncContainer(CardFuncEnums.whereLess, whereLessFunc, whereLessDiffFunc);

const whereGreaterFunc = (i, cardDataArr) => {
  const clonedDataArr = cardDataArr.map(cd => new CardData(cd.intVal, cd.cardFuncContainer));

  whereInPlace(clonedDataArr, (cardData, aIdx, a) => cardData.intVal > i);

  return clonedDataArr;
}

const whereGreaterDiffFunc = (i, cardDataArr) => {
  const clonedDataArr = cardDataArr.map((cd, cdIdx) => {
    const diffStatus = (cd.intVal > i) 
      ? CardDiffStatus.unchanged
      : CardDiffStatus.deleted;

    return new CardDiffData(cd.intVal, cd.cardFuncContainer, diffStatus, cdIdx)
  });

  return clonedDataArr;
}

const whereGreaterContainer  = new CardFuncContainer(CardFuncEnums.whereGreater, whereGreaterFunc, whereGreaterDiffFunc);

const moduloValFunc = (i, cardDataArr) => {
  const clonedDataArr = cardDataArr
    .map(cd => new CardData(cd.intVal % i, cd.cardFuncContainer));

  return clonedDataArr;
}

const moduloValDiffFunc = (i, cardDataArr) => {
  const clonedDataArr = cardDataArr
    .map((cd, cdIdx) => {
      return new CardDiffData(cd.intVal % i, cd.cardFuncContainer, CardDiffStatus.modified, cdIdx);
    });

  return clonedDataArr;
}

const moduloValContainer = new CardFuncContainer(CardFuncEnums.moduloVal, moduloValFunc, moduloValDiffFunc);


// perhaps this could be...duplicate at idx? I could see duplicate-4...being unreasonable confusing...
// I would probably never want something with that?
const duplicateFunc = (i, cardDataArr) => {
  const newDataArr = [];
  for (var cIdx = 0; cIdx < cardDataArr.length; cIdx++) {
    const cd = cardDataArr[cIdx];
    const cardToAdd = new CardData(cd.intVal, cd.cardFuncContainer);
    for (var dupIdx = 0; dupIdx < i; dupIdx++) {
      newDataArr.push(cardToAdd);
    }
  }

  return newDataArr;
}

const duplicateDiffFunc = (i, cardDataArr) => {
  const clonedDataArr = cardDataArr
    .flatMap((cd, cdIdx) => {
      const duplicatedSet = [];
      for (let j = 0; j < i; j++) {

        const diffStatus = j === 0
          ? CardDiffStatus.unchanged
          : CardDiffStatus.added;

        const prevIdx = j === 0
          ? cdIdx
          : undefined;

        const diffData = new CardDiffData(cd.intVal, cd.cardFuncContainer, diffStatus, prevIdx);

        duplicatedSet.push(diffData);
      }

      return duplicatedSet;
    });

    return clonedDataArr;
}

const duplicateContainer = new CardFuncContainer(CardFuncEnums.duplicate, duplicateFunc, duplicateDiffFunc);

const cardFuncEnumToContainer = Object.freeze({
  [CardFuncEnums.identity]: identityContainer,
  [CardFuncEnums.leftShift]: leftShiftContainer,
  [CardFuncEnums.rightShift]: rightShiftContainer,
  [CardFuncEnums.addToFront]: addToFrontContainer,
  [CardFuncEnums.prodToBack]: prodToBackContainer,
  [CardFuncEnums.whereLess]: whereLessContainer,
  [CardFuncEnums.whereGreater]: whereGreaterContainer,
  [CardFuncEnums.moduloVal]: moduloValContainer,
  [CardFuncEnums.duplicate]: duplicateContainer,
});

export {
  CardFuncEnums,
  cardFuncEnumToContainer,
  identityContainer,
  leftShiftContainer,
  rightShiftContainer,
  addToFrontContainer,
  prodToBackContainer,
  whereLessContainer,
  whereGreaterContainer,
  moduloValContainer,
  duplicateContainer,
};
